export function loadProductFormDependencies (vm) {
  if (!vm || typeof vm.apiRequest !== 'function') return

  const data = {
    token: vm.$session.get('token'),
    company_id: vm.$session.get('selectedCompany'),
    inactive: 1
  }

  if (!Array.isArray(vm.mainCategories) || !vm.mainCategories.length) {
    vm.apiRequest('/category', 'GET', data, (response) => {
      if (response.status === true) {
        vm.mainCategories = response.data
      }
    })
  }

  if (!Array.isArray(vm.taxes) || !vm.taxes.length) {
    vm.apiRequest('/location/taxes', 'GET', data, (response) => {
      if (response.status === true) {
        vm.taxes = response.data
      }
    })
  }

  if (!Array.isArray(vm.productOptions) || !vm.productOptions.length) {
    vm.apiRequest('/settings/general/' + data.company_id, 'GET', data, (response) => {
      if (response.status === true && response.data && response.data[0]) {
        vm.productOptions = response.data[0].products_options
      }
    })
  }

  if (!Array.isArray(vm.kdsSections) || !vm.kdsSections.length) {
    vm.apiRequest('/sections', 'GET', data, (response) => {
      if (response.status === true) {
        vm.kdsSections = response.data
      }
    })
  }

  if (!Array.isArray(vm.measurementsUnits) || !vm.measurementsUnits.length) {
    vm.apiRequest('/measurements-units', 'GET', data, (response) => {
      if (response.status === true) {
        vm.measurementsUnits = response.data
      }
    })
  }

  if (!Array.isArray(vm.languages) || !vm.languages.length) {
    vm.apiRequest('/company-data', 'GET', data, (response) => {
      if (response.status === true && response.data && response.data.company) {
        vm.languages = response.data.company.languages
        vm.language = response.data.company.language
      }
    })
  }

  if (!Array.isArray(vm.companyProductFilters) || !vm.companyProductFilters.length) {
    vm.apiRequest('/filter', 'GET', { ...data, from_product: 1 }, (response) => {
      if (response.status === true) {
        vm.companyProductFilters = response.data
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Products/productFormDependencies.js